"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let txGs1Base = {
    login: {
        classname: '.tx-mwlogin-view-normal',
        context: {},
        status: 0,
        sysLanguageUid: 0,
        formActionUrl: '/?eID=tx_mwlogin_eid',
        update: function () {
            let usernameInput = document.querySelector('input[type="text"]');
            let passwordInput = document.querySelector('input[type="password"]');
            usernameInput.setAttribute('autocomplete', 'off');
            passwordInput.setAttribute('autocomplete', 'off');
            txGs1Base.login.pollStatus();
        },
        pollStatus: function () {
            let pollStatus;
            let xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    document.querySelector('[data-faq-popularity-item]').innerHTML = this.responseText;
                }
            };
            xhttp.open("POST", pollStatus, true);
            xhttp.send();
        },
        getAndShowUsersNameAndCompany: function () {
            let getAndShowUsersNameAndCompany;
            let xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    document.querySelector('[data-faq-popularity-item]').innerHTML = this.responseText;
                }
            };
            xhttp.open("POST", getAndShowUsersNameAndCompany, true);
            xhttp.send();
        },
        sendLoginRequest: function () {
            let sendLoginRequest;
            let xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    document.querySelector('[data-faq-popularity-item]').innerHTML = this.responseText;
                }
            };
            xhttp.open("POST", sendLoginRequest, true);
            xhttp.send();
        },
        encryptPasswordAndSendLoginRequest: function () {
            let encryptPasswordSendLoginRequest;
            let xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    document.querySelector('[data-faq-popularity-item]').innerHTML = this.responseText;
                }
            };
            xhttp.open("POST", encryptPasswordSendLoginRequest, true);
            xhttp.send();
        },
        initialize: function () {
        }
    }
};
exports.default = {};
